"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadata = metadata;
exports.name = name;
const NoTransformConfigurationError_1 = require("./transformers/NoTransformConfigurationError");
/** @internal */
function metadata() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("reflect.metadata");
}
function name() {
    (0, NoTransformConfigurationError_1.NoTransformConfigurationError)("reflect.name");
}
//# sourceMappingURL=reflect.js.map